import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-marquee-component',
  templateUrl: './marquee-component.component.html',
  styleUrls: ['./marquee-component.component.scss']
})
export class MarqueeComponent  {
  @Input() speed;
}
